import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import PrintComponents from "react-print-components";
import printIcon from "../../../../assets/icons/print.svg";
import {
  ContentProvider,
  ContentMessage,
  Types,
  AlertContent,
} from "../../../../CommonComponents/ContentMessages";
import { fetchGrantData } from "../GrantsActivity/actions";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import {
  InfoField,
  TimeLineWrapper,
} from "./Component/ViewEditSchedules/style";
import {
  FixedWidth,
  PrimaryButtonComponent,
  SectionContent,
  PagesHeading,
  StyleLessButton,
} from "../../../../CommonComponents/commonStyles";
import {
  ButtonWrapper,
  GrantGhostButton,
  SectionMediumDivider,
  GrantSuccessMessage,
  AlertWrap,
  ViewAllWrap,
} from "./style";
import {
  IconPadding,
  DataExportPrint,
} from "../../../../Epics/MyAccounts/styles";
import { GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";
import prepareRender from "./utils";
import Step1Summary from "./Component/ViewEditSchedules/Components/Step1Summary";
import PermissionToPublish from "./Component/ViewEditSchedules/Components/PermissionToPublish";
import ViewRecurSchedule from "./Component/ViewEditSchedules/Components/ViewRecurSchedule";
import PreviewLetter from "./Component/ViewEditSchedules/Components/PreviewLetter";
import { fetchAccountAdvisors } from "../../../../actions/globalActions";
import Step2Summary from "./Component/ViewEditSchedules/Components/Step2Summary";
import InfoInline from "./Component/ViewEditSchedules/Components/InfoInline";
import RecommendGrantConfirmationPagePrint from "./RecommendGrantConfirmationPagePrint";
import { newGrant } from "./actions";
import { initiateTracking, recordError } from "../../../../utils/commonUtil";
import SoftAlert from "../../../../CommonComponents/Info/SoftAlert/SoftAlert.js";
import DrupalPopup from "./Component/Popup/DrupalPopup";
import TimeLine from "../../../../CommonComponents/TimeLine/TimeLine.js";

import { confirmationPageDerivedStates } from "./Selectors/ConfirmationPageSelectors";

const breadcrumbRoutes = () => {
  return [
    {
      routeName: "Home",
      path: "/",
    },
    {
      routeName: "Grants",
      path: "/grants",
    },
    {
      routeName: "Recommend a Grant",
      path: "/grants/recommend",
    },
  ];
};

export const analyticsHandler = (dataLayerName, event, name) => {
  try {
    initiateTracking(
      dataLayerName,
      "Grant Recommendation Confirmation",
      event,
      name
    );
  } catch (error) {
    recordError(error);
  }
};

export const PrintText = (props) => {
  return (
    <DataExportPrint>
      <a
        onClick={() => {
          analyticsHandler(
            "print",
            "",
            `Print - ${
              props.scheduleType === "recurring"
                ? `Recurring Grant`
                : `One Time Grant`
            }`
          );
        }}
      >
        {props.children}{" "}
      </a>
    </DataExportPrint>
  );
};

export const RecommendGrantConfirmation = (props) => {
  const {
    loading = true,
    location,
    fetchGrantData,
    history,
    enteredDate,
    grantTimeline,
    fastPass,
    startDate,
  } = props;
  const { grantId, scheduleId } = queryString.parse(location.search);
  const printRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    props.fetchAdvisors({ accountId: getPrimaryAccount().userId });
    return () => {
      // Clean up any existing data in store for recommend grant flow
      props.newGrant();
    };
  }, []);

  useEffect(() => {
    if (!grantId && !scheduleId) {
      setError(true);
      return;
    }
    fetchGrantData({
      userId: getPrimaryAccount().userId,
      grantId,
      scheduleId: scheduleId,
    });
  }, [grantId, scheduleId]);
  const [showError, setError] = useState(false);

  const {
    charityInfo,
    purposeRecognition,
    publishName,
    amountAllocation,
    scheduleData,
    codeValueMappingData,
  } = prepareRender(props);
  const { accountName, accountNumber } = getPrimaryAccount();

  if (loading) {
    return (
      <ContentProvider
        types={[
          Types.PAGE_ALERTS,
          Types.PAGE_NOTICES,
          Types.GET_CONFIRMATION_MESSAGE,
        ]}
        pages={["Recommend a Grant- Confirmation"]}
      >
        <DrupalPopup
          html={true}
          page={"Recommend a Grant- Confirmation"}
          show={showError}
          defaultPrimaryLabel={"Ok"}
          defaultTitle={"Something went wrong at our end"}
          showSecondary={false}
          keyProperty={"Grant Confirmation API error"}
          defaultDescription={
            "We do not understand the request. Please try again!"
          }
          primaryCta={() => setError(false)}
          alertId="confirmation-api-err"
        />
        <Preloader />
      </ContentProvider>
    );
  }
  return (
    <ContentProvider
      types={[Types.PAGE_NOTICES, Types.GET_CONFIRMATION_MESSAGE]}
      pages={["Recommend a Grant- Confirmation"]}
    >
      <FixedWidth>
        <div ref={printRef}>
          <BreadcrumbComponent
            className="hide-for-print"
            breadcrumbRoutes={breadcrumbRoutes()}
          />
          <PagesHeading>
            <ContentMessage
              type={[Types.GET_CONFIRMATION_MESSAGE]}
              page="Recommend a Grant- Confirmation"
              property="field_page_title"
              html={true}
              defaultMessage="Grant Recommendation Confirmation"
              messageId="confirmation"
            />
          </PagesHeading>
          <InfoField wordBreakOnly>
            <GrantSuccessMessage>
              <ContentMessage
                type={[Types.GET_CONFIRMATION_MESSAGE]}
                page="Recommend a Grant- Confirmation"
                property="field_success_message"
                html={true}
                messageId="confirmationText"
                defaultMessage="Congratulations! You have successfully submitted a grant recommendation."
              />
            </GrantSuccessMessage>
            <SoftAlert
              mainbody={
                <ContentMessage
                  page="Recommend a Grant- Confirmation"
                  type={Types.PAGE_NOTICES}
                  property="field_notice_content"
                  html={true}
                  messageId="confirmationContent"
                  defaultMessage="Your grant recommendation will be reviewed as soon as possible. If additional information is needed, someone will
                  reach out to you. The status of the grant recommendation can be found by logging in to your account and clicking on
                  Grants and then Grant Activity."
                />
              }
            />
          </InfoField>
          {grantId ? (
            <TimeLineWrapper>
              <TimeLine
                grantTimeline={fastPass ? grantTimeline : []}
                enteredDate={enteredDate}
                fastPass={fastPass}
                startDate={startDate}
              />
            </TimeLineWrapper>
          ) : (
            <SectionMediumDivider smallMarginBottom />
          )}
          <Row type="flex" justify="space-between" align="center">
            <Col span={24} lg={12}>
              <InfoInline
                title="Transaction ID"
                value={grantId ? grantId : scheduleId}
              />
              <InfoInline title="Entered Date" value={enteredDate} />
            </Col>
            <Col>
              <div className="right-align">
                <PrintComponents
                  className="i_print"
                  trigger={
                    <StyleLessButton id="btnPrint">
                      <IconPadding>
                        <img src={printIcon} alt="Print" />
                        <PrintText {...props}>PRINT</PrintText>
                      </IconPadding>
                    </StyleLessButton>
                  }
                >
                  <RecommendGrantConfirmationPagePrint
                    grantId={grantId}
                    scheduleId={scheduleId}
                    enteredDate={enteredDate}
                    charityInfo={charityInfo}
                    purposeRecognition={purposeRecognition}
                    codeValueMappingData={codeValueMappingData}
                    publishName={publishName}
                    amountAllocation={amountAllocation}
                    scheduleType={props.scheduleType}
                    scheduleData={scheduleData}
                    accountName={accountName}
                    accountNumber={accountNumber}
                  />
                </PrintComponents>
              </div>
            </Col>
          </Row>

          <SectionMediumDivider smallMarginTop />
          <Step1Summary
            charityInfo={charityInfo}
            purposeRecognition={purposeRecognition}
            codeValueMappingData={codeValueMappingData}
          />
          <SectionMediumDivider smallMarginBottom smallMarginTop />
          <PermissionToPublish publish={publishName} />
          <SectionMediumDivider smallMarginTop />
          <Step2Summary {...amountAllocation} />
          {props.scheduleType === "recurring" && (
            <>
              <SectionMediumDivider smallMarginTop />
              <ViewRecurSchedule
                title="Recurring Grant Schedule"
                scheduleData={scheduleData}
              />
              <SectionMediumDivider smallMarginTop />
            </>
          )}
        </div>
        {!scheduleId && (
          <>
            <SectionMediumDivider smallMarginBottom />
            <PreviewLetter {...props} analyticsHandler={analyticsHandler} />
            <SectionMediumDivider smallMarginTop />
          </>
        )}
        <ButtonWrapper>
          <ViewAllWrap>
            <GeneralButton
              id="btnViewAllGrants"
              type="functional"
              text="VIEW ALL GRANTS"
              mobWidth="100%"
              inverted
              onClick={() => {
                try {
                  history.push({ pathname: "/grants/activity" });
                } catch (error) {
                  recordError(error);
                }
              }}
            />
          </ViewAllWrap>
          <GeneralButton
            id="btnRecommendAnotherGrant"
            type="functional"
            text="RECOMMEND ANOTHER GRANT"
            mobWidth="100%"
            onClick={() => {
              try {
                history.push({ pathname: "/grants/recommend" });
              } catch (error) {
                recordError(error);
              }
            }}
          />
        </ButtonWrapper>
      </FixedWidth>
    </ContentProvider>
  );
};

const mapStateToProps = (state) => ({
  ...confirmationPageDerivedStates(state.toJS()),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchGrantData: (data) => dispatch(fetchGrantData(data)),
  fetchAdvisors: (data) => dispatch(fetchAccountAdvisors(data)),
  newGrant: (data) => dispatch(newGrant(data)),
});

RecommendGrantConfirmation.propTypes = {
  accountName: PropTypes.string,
  additionalComments: PropTypes.string,
  advisors: PropTypes.array,
  allShares: PropTypes.bool,
  allSharesAllPools: PropTypes.bool,
  allocations: PropTypes.array,
  amountType: PropTypes.string,
  charityAddress: PropTypes.object,
  charityEin: PropTypes.string,
  charityId: PropTypes.string,
  charityInterest: PropTypes.string,
  charityName: PropTypes.string,
  codeValueMappingData: PropTypes.object,
  endDate: PropTypes.string,
  enteredDate: PropTypes.string,
  eventName: PropTypes.string,
  fetchAdvisors: PropTypes.func,
  fetchGrantData: PropTypes.func,
  frequency: PropTypes.string,
  grantAmount: PropTypes.string,
  grantRecognition: PropTypes.string,
  history: PropTypes.object,
  inHonorOfName: PropTypes.string,
  inMemoryOfName: PropTypes.string,
  includeAdvisorInfo: PropTypes.bool,
  loading: PropTypes.bool,
  location: PropTypes.object,
  missionaryLocation: PropTypes.string,
  missionaryName: PropTypes.string,
  newGrant: PropTypes.string,
  noOfPayments: PropTypes.string,
  notifyFirstName: PropTypes.string,
  notifyLastName: PropTypes.string,
  projectName: PropTypes.string,
  publishName: PropTypes.bool,
  purposeCertification: PropTypes.bool,
  purposeId: PropTypes.number,
  purposeName: PropTypes.string,
  scheduleType: PropTypes.string,
  standardLanguage: PropTypes.string,
  startDate: PropTypes.string,
  staticContext: PropTypes.any,
  thirdParty: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RecommendGrantConfirmation)
);
